import { render, staticRenderFns } from "./RoundDuration.vue?vue&type=template&id=2a6b22a2&"
import script from "./RoundDuration.vue?vue&type=script&lang=js&"
export * from "./RoundDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6b22a2')) {
      api.createRecord('2a6b22a2', component.options)
    } else {
      api.reload('2a6b22a2', component.options)
    }
    module.hot.accept("./RoundDuration.vue?vue&type=template&id=2a6b22a2&", function () {
      api.rerender('2a6b22a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/RoundDuration.vue"
export default component.exports